import { NgModule } from '@angular/core';
import { ContainerComponent } from './components/container/container.component';
import { CommonModule } from '@angular/common';
import { RouterModule, RouterOutlet } from '@angular/router';
import { CoreRoutingModule } from './core.routing';
import { HttpClientModule } from '@angular/common/http';
import { HomeModule } from '../modules/home/home.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LoginModule } from '../modules/login/login.module';
import { HeaderComponent } from './components/parts/header/header.component';
import { TranslocoModule } from '@ngneat/transloco';
import { PrimeNgModule } from '../shared/modules/prime-ng.module';
import { ApplicationSettingsDialogComponent } from './dialogs/application-settings-dialog/application-settings-dialog.component';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    ContainerComponent,
    HeaderComponent,
    ApplicationSettingsDialogComponent,
  ],
  imports: [
    FormsModule,
    PrimeNgModule,
    CommonModule,
    HomeModule,
    LoginModule,
    RouterOutlet,
    CoreRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    TranslocoModule,
  ],
  providers: [],
  exports: [RouterModule, PrimeNgModule],
})
export class CoreModule {}
